import type { FC } from "react";
import styled from "styled-components";
import { IconWrapper, ItemText } from "../../NavigationBar/SidebarItemElements";
import { useSidebarState } from "../../NavigationBar/state";
import { ProfileAvatar } from "./ProfileAvatar";

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  color: var(--sinch-comp-color-menu-option-color-default-border-active);
`;

const Text = styled(ItemText)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

type ProfileAvatarNavItemProps = {
  onClick: () => void;
  name: string;
};
export const ProfileAvatarNavItem: FC<ProfileAvatarNavItemProps> = ({
  onClick,
  name,
}) => {
  const sidebarState = useSidebarState();
  return (
    <Button onClick={onClick}>
      <IconWrapper>
        <ProfileAvatar name={name} />
      </IconWrapper>
      {!sidebarState.isCollapsed && <Text noWrap>{name}</Text>}
    </Button>
  );
};
